import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import iconNoPhoto from '@/images/icon-no-photo.svg'
import styled from '@emotion/styled'

const StImgWrap = styled.div`
  .gatsby-image-wrapper {
    display: block;
  }
`

const Profileimage = ({ nombre, twitterImage, fotoImage }) => {
  if (fotoImage) {
    const image = getImage(fotoImage)
    return (
      <StImgWrap className="relative z-10 p-1 overflow-hidden bg-white rounded-full shadow-default ">
        {fotoImage && fotoImage.childImageSharp ? (
          <GatsbyImage
            className="overflow-hidden rounded-full"
            image={image}
            alt={nombre}
          />
        ) : (
          <img src={iconNoPhoto} />
        )}
      </StImgWrap>
    )
  }

  const twitterimage = getImage(twitterImage)

  if (twitterImage) {
    return (
      <StImgWrap className="relative z-10 p-1 overflow-hidden bg-white rounded-full shadow-default ">
        {twitterImage && twitterImage.childImageSharp ? (
          <GatsbyImage
            className="overflow-hidden rounded-full"
            image={twitterimage}
            alt={nombre}
          />
        ) : (
          <img src={iconNoPhoto} />
        )}
      </StImgWrap>
    )
  }

  return (
    <StImgWrap className="relative z-10 p-1 overflow-hidden bg-white rounded-full shadow-default ">
      <img src={iconNoPhoto} alt={nombre} />
    </StImgWrap>
  )
}

export default Profileimage
